/*
 * Copyright 2025, IntraLinks, Inc. All rights reserved.
 */

import { RequestsHandlerInstance } from '../utils/RequestsHandler';
import { IDealCentreRepository, IDealResponse } from '../IDealCentreRepository';

export default class DealCentreRepository implements IDealCentreRepository {
  private requestsHandler: RequestsHandlerInstance;

  private readonly rootResourcePath: string;

  private readonly dealCentreBaseUrl: string;

  constructor(requestsHandler: RequestsHandlerInstance, rootResourcePath: string, dealCentreBaseUrl: string) {
    this.requestsHandler = requestsHandler;
    this.rootResourcePath = rootResourcePath;
    this.dealCentreBaseUrl = dealCentreBaseUrl;
  }

  getDeals(): Promise<IDealResponse> {
    return this.requestsHandler.get(
      `${this.dealCentreBaseUrl}/${this.rootResourcePath}?fields=name`
    );
  }
}
